import React from 'react';

export const MOVIE_TICKET_LOGO_URL = 'https://s1.hdslb.com/bfs/live/20864a10beaea541c7dce264d5bbc56676d63e4f.png';

function MovieTicketIcon({ className = '', alt = '电影票' }) {
  return (
    <img
      src={MOVIE_TICKET_LOGO_URL}
      alt={alt}
      className={`movie-ticket-icon ${className}`.trim()}
    />
  );
}

export function MovieTicketAmount({ amount, suffix = '电影票', className = '' }) {
  return (
    <span className={`movie-ticket-inline ${className}`.trim()}>
      <MovieTicketIcon />
      <MovieTicketTextAmount amount={amount} suffix={suffix} />
    </span>
  );
}

export function MovieTicketTextAmount({
  amount,
  suffix = '电影票',
  separator = '',
  includeName = false,
  prefixName = false,
  className = ''
}) {
  const amountText = suffix ? `${amount}${separator}${suffix}` : `${amount}`;
  const text = prefixName
    ? `电影票 ${suffix === '电影票' ? amount : amountText}`
    : includeName
      ? (suffix === '电影票' ? amountText : `${amountText}电影票`)
      : amountText;

  return <span className={`movie-ticket-text ${className}`.trim()}>{text}</span>;
}

export default MovieTicketIcon;
